export const GET_WAREHOUSES: string = 'src/pages/warehouses/GET_WAREHOUSES';
export const GET_WAREHOUSES_SUCCESS: string =
  'src/pages/warehouses/GET_WAREHOUSES_SUCCESS';
export const GET_WAREHOUSES_FAILED: string =
  'src/pages/warehouses/GET_WAREHOUSES_FAILED';

export const UPDATE_WAREHOUSES: string =
  'src/pages/warehouses/UPDATE_WAREHOUSE';
export const UPDATE_WAREHOUSES_SUCCESS: string =
  'src/pages/warehouses/UPDATE_WAREHOUSE_SUCCESS';
export const UPDATE_WAREHOUSES_FAILED: string =
  'src/pages/warehouses/UPDATE_WAREHOUSE_FAILED';

export const GET_INVENTORY_ITEMS_WITH_SERIAL: string =
  'src/pages/warehouses/GET_INVENTORY_ITEMS_WITH_SERIAL';
export const GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS: string =
  'src/pages/warehouses/GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS';
export const GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED: string =
  'src/pages/warehouses/GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED';

export const CREATE_WAREHOUSES: string =
  'src/pages/warehouses/CREATE_WAREHOUSES';
export const CREATE_WAREHOUSES_SUCCESS: string =
  'src/pages/warehouses/CREATE_WAREHOUSES_SUCCESS';
export const CREATE_WAREHOUSES_FAILED: string =
  'src/pages/warehouses/CREATE_WAREHOUSES_FAILED';

export const GET_WAREHOUSES_INVENTORY: string =
  'src/pages/warehouses/GET_WAREHOUSES_INVENTORY';
export const GET_WAREHOUSES_INVENTORY_SUCCESS: string =
  'src/pages/warehouses/GET_WAREHOUSES_INVENTORY_SUCCESS';
export const GET_WAREHOUSES_INVENTORY_FAILED: string =
  'src/pages/warehouses/GET_WAREHOUSES_INVENTORY_FAILED';

export const GET_WAREHOUSE_OPERATORS_BY_ID: string =
  'src/pages/warehouses/GET_WAREHOUSE_OPERATORS_BY_ID';
export const GET_WAREHOUSE_OPERATORS_BY_ID_SUCCESS: string =
  'src/pages/warehouses/GET_WAREHOUSE_OPERATORS_BY_ID_SUCCESS';
export const GET_WAREHOUSE_OPERATORS_BY_ID_FAILED: string =
  'src/pages/warehouses/GET_WAREHOUSE_OPERATORS_BY_ID_FAILED';

export const GET_WAREHOUSES_INVENTORY_BY_ID: string =
  'src/pages/warehouses/GET_WAREHOUSES_INVENTORY_BY_ID';
export const GET_WAREHOUSES_INVENTORY_BY_ID_SUCCESS: string =
  'src/pages/warehouses/GET_WAREHOUSES_INVENTORY_BY_ID_SUCCESS';
export const GET_WAREHOUSES_INVENTORY_BY_ID_FAILED: string =
  'src/pages/warehouses/GET_WAREHOUSES_INVENTORY_BY_ID_FAILED';

export const GET_INVENTORY_ITEMS: string =
  'src/pages/warehouses/GET_INVENTORY_ITEMS';
export const GET_INVENTORY_ITEMS_SUCCESS: string =
  'src/pages/warehouses/GET_INVENTORY_ITEMS_SUCCESS';
export const GET_INVENTORY_ITEMS_FAILED: string =
  'src/pages/warehouses/GET_INVENTORY_ITEMS_FAILED';

export const CREATE_INVENTORY_ITEMS: string =
  'src/pages/warehouses/CREATE_INVENTORY_ITEMS';
export const CREATE_INVENTORY_ITEMS_SUCCESS: string =
  'src/pages/warehouses/CREATE_INVENTORY_ITEMS_SUCCESS';
export const CREATE_INVENTORY_ITEMS_FAILED: string =
  'src/pages/warehouses/CREATE_INVENTORY_ITEMS_FAILED';

export const UPDATE_WAREHOUSES_STATUS: string =
  'src/pages/warehouses/UPDATE_WAREHOUSES_STATUS';
export const UPDATE_WAREHOUSES_STATUS_SUCCESS: string =
  'src/pages/warehouses/UPDATE_WAREHOUSES_STATUS_SUCCESS';
export const UPDATE_WAREHOUSES_STATUS_FAILED: string =
  'src/pages/warehouses/UPDATE_WAREHOUSES_STATUS_FAILED';

export const GET_WAREHOUSE_WITH_ID: string =
  'src/pages/warehouses/GET_WAREHOUSE_WITH_ID';
export const GET_WAREHOUSE_WITH_ID_SUCCESS: string =
  'src/pages/warehouses/GET_WAREHOUSE_WITH_ID_SUCCESS';
export const GET_WAREHOUSE_WITH_ID_FAILED: string =
  'src/pages/warehouses/GET_WAREHOUSE_WITH_ID_FAILED';

export const UPDATE_WAREHOUSE_ADMIN: string =
  'src/pages/warehouses/UPDATE_WAREHOUSE_ADMIN';
export const UPDATE_WAREHOUSE_ADMIN_SUCCESS: string =
  'src/pages/warehouses/UPDATE_WAREHOUSE_ADMIN_SUCCESS';
export const UPDATE_WAREHOUSE_ADMIN_FAILED: string =
  'src/pages/warehouses/UPDATE_WAREHOUSE_ADMIN_FAILED';

export const GET_WAREHOUSE_CHILDREN: string =
  'src/pages/warehouses/GET_WAREHOUSE_CHILDREN';
export const GET_WAREHOUSE_CHILDREN_SUCCESS: string =
  'src/pages/warehouses/GET_WAREHOUSE_CHILDREN_SUCCESS';
export const GET_WAREHOUSE_CHILDREN_FAILED: string =
  'src/pages/warehouses/GET_WAREHOUSE_CHILDREN_FAILED';

export const GET_SKUS_INVENTORY: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY';
export const GET_SKUS_INVENTORY_SUCCESS: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_SUCCESS';
export const GET_SKUS_INVENTORY_FAILED: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_FAILED';

export const GET_SKUS_INVENTORY_FINALIZED_SUM: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_FINALIZED_SUM';
export const GET_SKUS_INVENTORY_FINALIZED_SUM_SUCCESS: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_FINALIZED_SUM_SUCCESS';
export const GET_SKUS_INVENTORY_FINALIZED_SUM_FAILED: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_FINALIZED_SUM_FAILED';

export const GET_SKUS_INVENTORY_NOT_FINALIZED_SUM: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_NOT_FINALIZED_SUM';
export const GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_SUCCESS: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_SUCCESS';
export const GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_FAILED: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_FAILED';

export const GET_SKUS_INVENTORY_BY_ID: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_BY_ID';
export const GET_SKUS_INVENTORY_BY_ID_SUCCESS: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_BY_ID_SUCCESS';
export const GET_SKUS_INVENTORY_BY_ID_FAILED: string =
  'src/pages/warehouses/GET_SKUS_INVENTORY_BY_ID_FAILED';

export const GET_PARCELS_ITEMS: string =
  'src/pages/warehouses/GET_PARCELS_ITEMS';
export const GET_PARCELS_ITEMS_SUCCESS: string =
  'src/pages/warehouses/GET_PARCELS_ITEMS_SUCCESS';
export const GET_PARCELS_ITEMS_FAILED: string =
  'src/pages/warehouses/GET_PARCELS_ITEMS_FAILED';
